const virusTripModule = {
  namespaced : true,

  state : {
    allVirusTrip   : [],
    searchDate     : '',
    searchType     : 'all',
    travelNumber   : '',
    city           : '',
    sortMode       : 'publishTimeDescend',
    showMenuWindow : false,
    filterList     : [ 'flight', 'train', 'other' ],
    updateTime     : '',
    pageNumber     : 0,
    pageCount      : 20,
    pageLoading    : false,
    userVirusTrip  : [],
    idList         : [],
    idVirusTrip    : []
  },

  mutations : {
    updateAllVirusTrip : ( state, payload ) => {
      state.allVirusTrip = payload;
      state.pageNumber   = 0;
    },

    updateSearchDate : ( state, payload ) => {
      state.searchDate = payload;
      state.pageNumber = 0;
    },

    updateSearchType : ( state, payload ) => {
      state.searchType   = payload;
      state.travelNumber = '';
      state.pageNumber   = 0;
    },

    updateTravelNumber : ( state, payload ) => {
      state.travelNumber = payload.replace( /\s/g, '' ).toUpperCase();
      state.pageNumber   = 0;
    },

    updateCity : ( state, payload ) => {
      state.city       = payload;
      state.pageNumber = 0;
    },

    updateSortMode : ( state, payload ) => {
      state.sortMode   = payload;
      state.pageNumber = 0;
    },

    updateShowMenuWindow : ( state, payload ) => {
      state.showMenuWindow = payload;
    },

    updateFilterList : ( state, payload ) => {
      state.filterList = payload;
      state.pageNumber = 0;
    },

    updateUpdateTime : ( state, payload ) => {
      state.updateTime = payload;
    },

    updatePageNumber : ( state, payload ) => {
      state.pageNumber = payload;
    },

    updatePageLoading : ( state, payload ) => {
      state.pageLoading = payload;
    },

    updateUserVirusTrip : ( state, payload ) => {
      state.userVirusTrip = payload;
    },

    updateIdList : ( state, payload ) => {
      state.idList = payload;
    },

    updateIdVirusTrip : ( state, payload ) => {
      state.idVirusTrip = payload;
    },

    initStore : ( state, payload ) => {
      for ( let key in payload ) {
        if ( state.hasOwnProperty( key ) ) {
          state[ key ] = payload[ key ];
        }

        console.log( key );
        console.log( state[ key ] );
      }
    }
  },

  getters : {
    virusTripList : ( state ) => {
      let result;

      const {
        sortMode,      searchType,   city,
        searchDate,    travelNumber, filterList,
        userVirusTrip, idVirusTrip
      } = state;

      result = [ ...state.allVirusTrip ];

      const filterByDateAndTravelNumber = ( list ) => {
        if ( searchDate ) {
          list = list.filter( ( item ) => {
            return item.tripDate.indexOf( searchDate ) >= 0;
          } );
        }

        if ( travelNumber ) {
          list = list.filter( ( item ) => {
            return new RegExp( travelNumber, 'i' ).test( item.tripNo );
          } );
        }

        return list;
      };

      const filterByFilterList = ( list ) => {
        list = list.filter( ( item ) => {
          let result;

          const isFlight = item.tripType === 'flight';
          const isTrain = item.tripType === 'train';
          const isOther = !isFlight && !isTrain;

          if ( filterList.indexOf( 'flight' ) >= 0 ) {
            result = isFlight;
          }

          if ( filterList.indexOf( 'train' ) >= 0 ) {
            result = result || isTrain;
          }

          if ( filterList.indexOf( 'other' ) >= 0 ) {
            result = result || isOther;
          }

          return result;
        } );

        return list;
      };

      // const filterByIdList = ( list ) => {
      //   list = list.filter( ( item ) => {
      //     return idList.indexOf( item.id ) >= 0;
      //   } );

      //   return list;
      // };

      if ( searchType === 'train' ) {
        result = result.filter( ( item ) => {
          return item.tripType === 'train';
        } );

        result = filterByDateAndTravelNumber( result );
      } else if ( searchType === 'flight' ) {
        result = result.filter( ( item ) => {
          return item.tripType === 'flight';
        } );

        result = filterByDateAndTravelNumber( result );
      } else if ( searchType === 'city' ) {
        if ( city ) {
          result = result.filter( ( item ) => {
            return item.nameIndex.indexOf( city ) >= 0;
          } );
        }

        result = filterByFilterList( result );
      } else if ( searchType === 'user' ) {
        result = [ ...userVirusTrip ];
      } else if ( searchType === 'id' ) {
        // result = filterByIdList( result );
        result = [ ...idVirusTrip ];
      } else {
        result = filterByFilterList( result );
      }

      if ( sortMode === 'dateDescend' ) {
        result.sort( ( a, b ) => {
          return a.tripDeptime > b.tripDeptime ? -1 : 1;
        } );
      } else if ( sortMode === 'dateAscend' ) {
        result.sort( ( a, b ) => {
          return a.tripDeptime < b.tripDeptime ? -1 : 1;
        } );
      } else if ( sortMode === 'publishTimeDescend' ) {
        result.sort( ( a, b ) => {
          return a.publishtime > b.publishtime ? -1 : 1;
        } );
      } else if ( sortMode === 'publishTimeAscend' ) {
        result.sort( ( a, b ) => {
          return a.publishtime < b.publishtime ? -1 : 1;
        } );
      }

      return result;
    }
  }
};

export default virusTripModule;



// WEBPACK FOOTER //
// ./src/projects/virusTrip/store/virus-trip-module.js